import React from 'react';
import TextField from '@material-ui/core/TextField';
import ErrorMessage from '../ErrorMessage';
import Select from '../Select';
import SelectMultiple from '../SelectMultiple';
import NumberField from '../NumberField';
import SelectRemote from '../SelectRemote';
import DatePicker from '../DatePicker';

export default function FormField(props) {
  const { errors, children } = props;
  const hasErrors = errors && errors.length > 0;
  if (props.type === 'text' || props.type === 'password') {
    return (
      <TextField
        {...props}
        error={hasErrors}
        helperText={hasErrors ? <ErrorMessage errors={errors} /> : null}
      >
        {children}
      </TextField>
    );
  }
  if (props.type === 'select') {
    return <Select {...props} />;
  }
  if (props.type === 'multi_select') {
    return <SelectMultiple {...props} />;
  }
  if (props.type === 'number_field') {
    return <NumberField {...props} />;
  }
  if (props.type === 'remoteSelect') {
    return <SelectRemote {...props} />;
  }
  if (props.type === 'date') {
    return <DatePicker {...props} />;
  }
  return null;
}
